module.exports = __webpack_public_path__ + "img/fleetex-log-in-logo.1e49ed0d.png";